import React, { useState, useEffect } from "react";
import VisDiv from "../components/VisDiv";
import { keyId } from "../lib/utils";
import { FaBold, FaItalic, FaUnderline } from "react-icons/fa";
import { GoListUnordered, GoListOrdered } from "react-icons/go";
import { generateMongoDBId } from "../lib/utils";

import { Editor, EditorState, RichUtils, convertFromRaw, convertToRaw } from "draft-js";
import "draft-js/dist/Draft.css";

const RichTextEditor = ({text="", onBlur=()=>{}, nChar, noFocus, placeHolder, existingDoc, readOnly, fullWidth, customWidth ="100rem", saveLoad, editorDoc = ()=> {}, updateInitialData}) => {
  const doc = {
    blocks:[
      {
        key: keyId(),
        text,
        type:"unstyled"
      }
    ],
    entityMap:{}
  }
  const addDefaultRichText = (newDoc = {}) => (
    {
      ...newDoc,
      entityMap: { _key: newDoc?.entityMap?._key ? newDoc?.entityMap?._key : generateMongoDBId() }, 
      _key: newDoc?.key ? newDoc?.key : generateMongoDBId(),
      _id: newDoc?._id ? newDoc?._id : generateMongoDBId(), 
      _type: newDoc?._type ? newDoc?._type : "richTextObject"
      }
      )

  const initialData = () => {
    if (existingDoc?.blocks?.length > 0){ 
      //process.env.NODE_ENV === "development" && console.log("existingDoc", existingDoc)
      return EditorState?.createWithContent(convertFromRaw(addDefaultRichText(existingDoc)))}
    return EditorState.createEmpty()
  }

  useEffect(()=>{
    if(updateInitialData){
      setEditorState(initialData())
    }
  },[existingDoc])

  const [editorState, setEditorState] = useState(initialData());
  const [savedContent, setSavedContent] = useState({})
  const testing = false
  const testFunction = () => {
      console.log("editorState", convertToRaw(editorState?.getCurrentContent()), editorState?.getCurrentContent())
  }
  const saveContent = () => {
      //process.env.NODE_ENV === "development" && console.log("editorState", convertToRaw(editorState?.getCurrentContent()))
      setSavedContent(convertToRaw(editorState?.getCurrentContent()))
  }
  const loadContent = () => {
      setEditorState(EditorState.createWithContent(convertFromRaw(savedContent)))
  }

  const editor = React.useRef(null);

  function focusEditor() {
    editor?.current.focus();
  }

  useEffect(() => {
    if(!noFocus){
      focusEditor();
    }
  }, []);

  const StyleButton = (props) => {
    let onClickButton = (e) => {
      e.preventDefault();
      props.onToggle(props.style);
    };
    return <div style={{border:"none", padding:"5px", cursor:"pointer"}} onMouseDown={onClickButton}>{props.icon}{props.label}</div>;
  };

  const BLOCK_TYPES = [
    { label: "UL", style: "unordered-list-item", icon: <GoListUnordered size={18} color={"grey"}/> },
    { label: "OL", style: "ordered-list-item" , icon: <GoListOrdered size={18} color={"grey"}/>},
  ];

  const BlockStyleControls = (props) => {
    return (
      <div style={{display:"flex"}}>
        {BLOCK_TYPES?.map((type) => (
          <StyleButton
            key={type?.label}
            icon={type?.icon}
            onToggle={props?.onToggle}
            style={type?.style}
          />
        ))}
      </div>
    );
  };

  const INLINE_STYLES = [
    { label: "Bold", style: "BOLD", icon: <FaBold size={18} color={"grey"}/>},
    { label: "Italic", style: "ITALIC", icon: <FaItalic size={18} color={"grey"}/> },
    { label: "Underline", style: "UNDERLINE", icon: <FaUnderline size={18} color={"grey"}/> },
  ];

  const InlineStyleControls = (props) => {
    return (
      <div style={{display:"flex"}}>
        {INLINE_STYLES?.map((type) => (
          <StyleButton
            key={type?.label}
            icon={type?.icon}
            onToggle={props?.onToggle}
            style={type?.style}
          />
        ))}
      </div>
    );
  };


  const onInlineClick = (e) => {
    let nextState = RichUtils.toggleInlineStyle(editorState, e);
    setEditorState(nextState);
    const newDoc = convertToRaw(nextState.getCurrentContent())
    editorDoc(addDefaultRichText(newDoc))
  };

  const onBlockClick = (e) => {
    let nextState = RichUtils.toggleBlockType(editorState, e);
    setEditorState(nextState);
    const newDoc = convertToRaw(nextState.getCurrentContent())
    editorDoc(addDefaultRichText(newDoc))
  };

  const border = readOnly ? {border:"none"} : {cursor:"text", borderRadius:"10px", borderColor: "#ccc", fontSize:"16px"}
  const maxWidth = fullWidth ? {} : {maxWidth: customWidth}

  const handleBeforeInput = (chars) => {
    if (nChar && typeof nChar === 'number') {
      const currentLength = editorState.getCurrentContent().getPlainText('').length;
      if (currentLength >= nChar) {
        return 'handled';
      }
    }
    return 'not-handled';
  };

  const handlePastedText = (text) => {
    if (nChar && typeof nChar === 'number') {
      const currentLength = editorState.getCurrentContent().getPlainText('').length;
      if (currentLength + text.length > nChar) {
        return 'handled';
      }
    }
    return 'not-handled';
  };

  const onChange = (editorState) => {
    const newDoc = convertToRaw(editorState?.getCurrentContent())
    setEditorState(editorState)
    editorDoc({...newDoc, _key: newDoc?.key ? newDoc?.key : generateMongoDBId(), _id: newDoc?._id ? newDoc?._id : generateMongoDBId(), _type: newDoc?._type ? newDoc?._type : "richTextObject"})
  }

  const getCurrentCharCount = () => {
    return editorState.getCurrentContent().getPlainText('').length;
  };

  return (
    <>
      <VisDiv rules={[testing, !readOnly]}><button onClick={testFunction}>Test</button></VisDiv>
      <VisDiv rules={[!readOnly, saveLoad]}><button onClick={saveContent}>Save Content</button></VisDiv>
      <VisDiv rules={[!readOnly, saveLoad]} ><button onClick={loadContent}>Load Content</button></VisDiv>
      <div onClick={focusEditor} style={{ position: 'relative' }}>
        <VisDiv rules={[!readOnly]} style={{...border, color:"blue", display:"flex", ...maxWidth}} className="rich-editor">
          <BlockStyleControls onToggle={onBlockClick} />
          <InlineStyleControls onToggle={onInlineClick} />
        </VisDiv>
        <div style={{
          ...border,
          ...maxWidth,
          paddingBottom: nChar && typeof nChar === 'number' ? '35px' : undefined
        }} className="rich-editor">
          <Editor
            ref={editor}
            editorState={editorState}
            placeholder={placeHolder}
            onChange={onChange}
            readOnly={readOnly}
            onBlur={onBlur}
            handleBeforeInput={handleBeforeInput}
            handlePastedText={handlePastedText}
          />
          {nChar && typeof nChar === 'number' && (
            <div style={{
              position: 'absolute',
              bottom: '12px',
              right: '10px',
              fontSize: '12px',
              color: getCurrentCharCount() >= nChar ? '#ff4444' : '#666',
              padding: '2px 5px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '3px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
              {getCurrentCharCount()}/{nChar}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RichTextEditor
